import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token!: string | null;

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  login(email: string, password: string) {
    this.token = JSON.stringify({
      value: 'token',
      expires: new Date(new Date().getTime() + 172800000).toISOString()
    });
    localStorage.setItem('token', this.token);
    this.router.navigate(['/articles']);
  }

  getToken() {
    const token = localStorage.getItem('token');
    if (token) {
      this.token = token;
    }
    return this.token;
  }

  logout() {
    this.token = null;
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }
}